import accountreconciliationPage from './accountreconciliation-page.html'

const page             = require('../../../../../components/page/page')
const reconciliationDt = require('./accountreconciliation-dt')
var HTMLwasSelected = false

function HTMLselect() {
  document.body.insertAdjacentHTML('beforeend', accountreconciliationPage)
  HTMLwasSelected = true
  reconciliationDt.start({ act: 'select', entity: 'accountreconciliation' })
}

export function start(detail) {
  if (!HTMLwasSelected) HTMLselect()
  if (detail.act === 'show') page.start(detail)
}
